<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-30 10:40:50
 * @LastEditTime: 2021-02-24 16:43:36
-->
<template>
  <div>
    <el-tag
      :key="index"
      v-for="(tag, index) in dynamicTags"
      :disable-transitions="false"
      @close="handleClose(tag)"
    >
      {{ tag.name }}
    </el-tag>
    <el-input
      class="input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      size="small"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    >
    </el-input>
    <el-button v-else class="button-new-tag" size="small" @click="showInput"
      >+ 新增 Tag</el-button
    >
  </div>
</template>

<script>
import { addTag, tagsList } from "@/api/chat";
export default {
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      tagsList().then((res) => {
        localStorage.setItem("tag", JSON.stringify(res));
        this.dynamicTags = res.tags;
      });
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        addTag({ tag: this.inputValue })
          .then((res) => {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.getData();

            this.inputVisible = false;
            this.inputValue = "";
          })
          .catch((err) => {
            this.$message({
              message: "新增失败，请稍后再试",
              type: "warning",
            });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>